import React, { FC } from "react";
import "./MaxButton.scss";
const MaxButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <button className="max-button" onClick={onClick}>
      Max
    </button>
  );
};

export default MaxButton;
